/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum Flags {
  CLICKABLE = 0,
  ENABLED = 1,
  FOCUSABLE = 2,
  FOCUSED = 3,
  PRESSED = 4,
  SELECTED = 5,
  ACTIVATED = 6,
  HOVERED = 7,
  BLOCKED = 8,
  OPAQUE = 9,
  HARDWARE_ACCELERATED = 10,
  VIEW_GROUP_CLIP_CHILDREN = 11,
  VIEW_GROUP_CLIP_TO_PADDING = 12,
  WEBVIEW = 13,
  SCRUBBED = 14,
  MASKED = 15,
}
